// extracted by mini-css-extract-plugin
export default {"app":"App_app__GNzSr","main":"App_main__9J0sx","dashboard":"App_dashboard__pumAr","main-contant":"App_main-contant__FXtT5"};